// library imports
import { useState } from "react";
// hook imports
import useFetch from "../hooks/useFetch";

export default function useHasTnb() {
  const [fetchWrapper] = useFetch();

  // loading state
  const [getHasTnbLoading, setGetHasTnbLoading] = useState(false);

  // this state is to check whether the site has TNB meter
  const [hasTnb, setHasTnb] = useState(false);

  /* API to check whether site has TNB meter that is selected and not deleted */
  function getHasTnb({ siteSelected }) {
    setGetHasTnbLoading(true);
    fetchWrapper({
      endpoint_url: "layout/getHasDevice",
      method: "GET",
      set_content_type_header: false,
      params: {
        site_id: siteSelected,
        device_prefix: "INCOMING",
      },
      onSuccess: (response) => {
        setGetHasTnbLoading(false);
        setHasTnb(response.data);
      },
    });
  }

  return [hasTnb, getHasTnb, getHasTnbLoading];
}
